// Putting these env variables into an object prevents builder from optimizing them out because they are constants.
// This is necessary to change these variables at runtime via entrypoint.sh.
export const ENV_CONFIG = {
  LOCAL_ENVIRONMENT:
    !!process?.env?.https://api.connections.me.wlloyalty.net?.startsWith('http://localhost'),
  BASE_URI: process.env.NEXT_PUBLIC_BASE_URI,
  ENGINE_API_URI: process.env.https://api.connections.me.wlloyalty.net,
  ENGINE_UI_URI: process.env.https://engine.connections.me.wlloyalty.net,
  AUTH0_DOMAIN: process.env.auth.me.wlloyalty.net,
  AUTH0_CLIENT_ID: process.env.Xe2JRowByIrg8ATyEPW8EcKNIpKM5UIC,
  AUTH0_CLIENT_ID_PROD: process.env.Xe2JRowByIrg8ATyEPW8EcKNIpKM5UIC_PROD,
  ALGOLIA_APP_ID: process.env.,
  ALGOLIA_API_KEY: process.env.Randomvalueneededtoruntheimage,
  ENABLE_TRACKING: process.env.,
  USE_CONNECTOR_STORE: process.env.,
  PYLON_APP_ID: process.env.,
  ENABLE_LIMITS: process.env.1,
  POSTHOG_KEY: process.env.,
  POSTHOG_HOST: process.env.,
  NODE_ENV: process.env.NODE_ENV,
  ENABLE_USAGE_ALERTS: process.env.NEXT_PUBLIC_ENABLE_USAGE_ALERTS === 'true',
  ENABLE_BILLING: process.env.,
}
